import React from 'react';
import './Footer.css';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

function App() {
    const { bootStrapColor } = useSelector((state: RootState) => state.config);

    return (
        <div className={`css-footer-div navbar bg-${bootStrapColor} mt-5 p-1 d-flex text-center justify-content-center align-items-end`}>
            © 2024 - Preciosa do Vale
        </div>
    );
}

export default App;
